/**
 * The viewport-fit rule for centred overlay panels, in one place.
 *
 * A `Dialog`/`AlertDialog` panel is `position: fixed` and centred with
 * `translate(-50%, -50%)`, so without a height bound it grows past the window in
 * BOTH directions at once: the title goes off the top, the footer goes off the
 * bottom, and because the panel is not a scroll container there is nothing to
 * scroll to reach either (VALE-1438 — measured at 1280x600, the beneficiary
 * banking-details review modal rendered 678px tall from y=-39 to y=639, with
 * Approve 18px below the fold and the close button entirely above it).
 *
 * Both primitives apply this, so every dialog in the app inherits it.
 *
 * A call site may still override either half through `cn()` — tailwind-merge
 * resolves `max-h-*` and `overflow-*` by group, so a panel that manages its own
 * scrolling keeps doing so. **An override must stay viewport-relative** (`vh` /
 * `dvh`): a fixed px/rem cap, or `max-h-none`, re-opens exactly this defect at a
 * shorter viewport, and `__tests__/dialog-viewport-fit.test.tsx` enumerates every
 * call site to hold that line.
 *
 * `dvh` rather than `vh` so a mobile browser's collapsing chrome is accounted
 * for; the 2rem is 1rem of breathing room above and below the centred panel.
 */
export const DIALOG_VIEWPORT_FIT = 'max-h-[calc(100dvh-2rem)] overflow-y-auto';
